import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, BookOpen, ShieldCheck, Users, Phone } from 'lucide-react';
export function AboutPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-259">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-260">
        <div className="max-w-4xl mx-auto text-center" data-id="element-261">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-262">
            <Users className="w-8 h-8 text-[#0e7be1]" data-id="element-263" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-264">
              About Us
            </h1>
          </div>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full" data-id="element-265"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-266">
        {/* Our Story */}
        <section data-id="element-267">
          <div className="flex items-center gap-3 mb-4" data-id="element-268">
            <Heart className="w-6 h-6 text-[#0e7be1]" data-id="element-269" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-270">Our Story</h2>
          </div>
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-271">
            <p className="mb-4" data-id="element-272">
              At BestVitaminsForAll.com we are passionate about health! We spent
              over 7 years searching and trying different kinds of supplements
              until we found GNLD.
            </p>
            <p className="mb-4" data-id="element-273">
              A few days after we tried GNLD supplements we knew they were
              different from everything else we'd tried. We immediately decided
              to become a GNLD distributor in February 2009 and ever since we
              have been helping hundreds of people maintaining and achieving
              good health.
            </p>
          </div>
        </section>

        {/* Our Commitment */}
        <section data-id="element-274">
          <div className="flex items-center gap-3 mb-4" data-id="element-275">
            <BookOpen className="w-6 h-6 text-[#0e7be1]" data-id="element-276" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-277">
              Our Commitment to You
            </h2>
          </div>
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-278">
            <p className="mb-4" data-id="element-279">
              At BestVitaminsForAll.com, we are currently studying Naturopathy,
              and constantly learning more about health so we can answer our
              customers' health questions.
            </p>
            <p className="mb-4" data-id="element-280">
              Feel free to ask us any health related questions and we'll answer
              them to the best of our ability. Feel free to ask us our
              recommendation or suggestions for any health conditions. We are
              here to serve you.
            </p>
          </div>
        </section>

        {/* Privacy & Security */}
        <section className="bg-blue-50 p-8 rounded-2xl border border-blue-100" data-id="element-281">
          <div className="flex items-center gap-3 mb-4" data-id="element-282">
            <ShieldCheck className="w-6 h-6 text-[#0e7be1]" data-id="element-283" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-284">
              Your Privacy & Security
            </h2>
          </div>
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-285">
            <p data-id="element-286">
              We want you to know that all information you share with us will be
              kept private between you and us and our website is very secure.
              You can shop with great confidence here!
            </p>
          </div>
        </section>

        {/* Closing */}
        <div className="text-center" data-id="element-287">
          <p className="text-xl font-semibold text-gray-900 mb-6" data-id="element-288">
            Have a wonderful experience with GNLD!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-289">
            <Link to="/contact" className="inline-block bg-[#0e7be1] hover:bg-[#0c6bc4] text-white font-semibold text-sm px-6 py-3 rounded-lg transition-colors" data-id="element-290">
              Contact Us
            </Link>
            <a href="tel:800-260-2808" className="inline-flex items-center text-[#0e7be1] font-semibold text-sm hover:underline" data-id="element-291">
              <Phone className="h-4 w-4 mr-2" data-id="element-292" />
              800-260-2808
            </a>
          </div>
        </div>
      </div>
    </div>;
}